var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShieldOutline = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.3346 8.66664C13.3346 12 11.0013 13.6666 8.22797 14.6333C8.08274 14.6825 7.92499 14.6802 7.7813 14.6266C5.0013 13.6666 2.66797 12 2.66797 8.66664V3.99997C2.66797 3.82316 2.73821 3.65359 2.86323 3.52857C2.98826 3.40355 3.15782 3.33331 3.33464 3.33331C4.66797 3.33331 6.33464 2.53331 7.49464 1.51997C7.63587 1.39931 7.81554 1.33301 8.0013 1.33301C8.18707 1.33301 8.36673 1.39931 8.50797 1.51997C9.67464 2.53997 11.3346 3.33331 12.668 3.33331C12.8448 3.33331 13.0143 3.40355 13.1394 3.52857C13.2644 3.65359 13.3346 3.82316 13.3346 3.99997V8.66664Z",
  strokeWidth: 1.33333,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  stroke: "currentcolor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgShieldOutline);
export default ForwardRef;